/**
 * SW Event Tracking
 *
 * This module is used to send tracking data to
 * tracking services such as mixpanel and track api.
 *
 * This module should only be used by the sw-track autohandler
 * but there are some snowflake usages of swEventTracking.track
 * which is aliased to sw.track.
 */

var $ = require('js/sw-jquery/sw-jquery');
var _ = require('underscore');

if (window.sw.data.mixpanelToken) {
  require('./sw-mixpanel')(window.sw.data.mixpanelToken);
}

var swEventTracking = {

  /**
   * Supported services
   */
  SERVICES: {
    EVENT_TRACKING: 'event-tracking',
    DATALAYER: 'dataLayer',
    ACTIVITY_TRACKING: 'activity-tracking'
  },

  /**
   * Send the tracking data to tracking services.
   * Also adds some tracking data form the client.
   *
   * @param eventName
   * @param data
   * @param options
   */
  track: function (eventName, data, options) {
    options = options || {};

    var trackingServices = options.trackingServices || [swEventTracking.SERVICES.EVENT_TRACKING];
    if (typeof trackingServices === 'string') {
      trackingServices = trackingServices.split(' ');
    }

    if (eventName) {
      data.event = eventName;
    }
    data.request_tracking_id = window.sw.data.requestTrackingId || '';
    data.viewport_width = $.swViewportWidth();
    data.viewport_height = $.swViewportHeight();
    data.referrer = document.referer;

    if (_.includes(trackingServices, swEventTracking.SERVICES.EVENT_TRACKING)) {
      $.ajax({
        type: 'POST',
        url: '/api/track',
        data: data
      });
    }

    if (_.includes(trackingServices, swEventTracking.SERVICES.ACTIVITY_TRACKING)) {
      $.ajax({
        type: 'POST',
        url: '/at',
        data: data
      });
    }

    if (window.dataLayer && _.includes(trackingServices, swEventTracking.SERVICES.DATALAYER)) {
      // Push an event to the dataLayer so it can be seen in Google Tag Manager
      const eventData = {};
      if (eventName) {
        eventData.event = eventName;
      }
      window.dataLayer.push(Object.assign(eventData, data));
    }
  },

  /**
   * Given tracking data, reorganize data for call to track function.
   *
   * @param trackingData
   */
  handleTracking: function handleTracking(trackingData) {
    var eventName = trackingData.swTracking;

    var options = {};
    var trackingServices = trackingData.swTrackingServices;
    if (trackingServices) {
      options.trackingServices = trackingServices.split(' ');
    }

    var filteredTrackingData = _.omit(trackingData, ['swTracking', 'swTrackingTrigger']),
        reducedTrackingData = _.reduce(filteredTrackingData, function(reducedTrackingData, item, key, filteredTrackingData) {
          reducedTrackingData[key.replace('swTracking', '')] = filteredTrackingData[key];
          return reducedTrackingData;
        }, {});

    swEventTracking.track(eventName, reducedTrackingData, options);
  }
};

module.exports = swEventTracking;
